
import { KYMW2500Model } from '../kymw2500.model';
import { PagenationRequestModel } from '../vo/pagenation-request.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ページネーション設定削除コマンド
 * サーバーにページネーション設定削除をリクエストし、結果を表示する。
 *
 * @export DeletePageCopyLineService
 * @class DeletePageCopyLineService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class DeletePageCopyLineService extends PlessJsonResponderSub<any> {
  private model: KYMW2500Model = null;
  private vo: PagenationRequestModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeletePageCopyLineService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      delete: {
        Rec: {
          condition: {
            MediumType: this.vo.MediumType,
            OrderCode: this.vo.OrderCode,
            CoopCode: this.vo.CoopCode
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW2500Model} model モデルクラス
   * @param {PagenationRequestModel} vo ページネーションリクエストVO
   * @memberof DeletePageCopyLineService
   */
  execute(model: KYMW2500Model, vo: PagenationRequestModel) {
    this.model = model;
    this.vo = vo;
    this.send('deletePageCopyLine', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeletePageCopyLineService
   */
  success(data: any) {
    // ページネーション選択エリアのボタンを非活性化する
    this.model.kymw2500Component.disablePagenationListButton();
    // ページネーション詳細エリアを非活性化する
    this.model.kymw2500Component.disablePagenationDetail();
    // データグリッド「ページネーション一覧設定」から選択行を削除
    this.model.deletePagenationListLine(this.vo.SelectedIndex);
    // ページネーション詳細エリアをクリア
    this.model.kymw2500Component.clearPagenationDetail();
  }
}
